import { render, staticRenderFns } from "./ModalSurveySubmit.vue?vue&type=template&id=a0203de4&"
import script from "./ModalSurveySubmit.vue?vue&type=script&lang=js&"
export * from "./ModalSurveySubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports